import { createContext, useContext, useMemo } from 'react'

const AuthContext = createContext({
  getAuthToken: async (): Promise<string> => {
    throw new Error('getAuthToken auth function not implemented')
  },
  handleUnauthorized: undefined as ((rejectedToken?: string) => Promise<string | null>) | undefined,
})

type AuthProviderType = {
  getAuthToken: () => Promise<string> // Top-level HL auth token
  handleUnauthorized?: (rejectedToken?: string) => Promise<string | null>
}

export const AuthProvider: React.FC<React.PropsWithChildren<AuthProviderType>> = ({
  children,
  getAuthToken,
  handleUnauthorized,
}) => {
  const value = useMemo(() => ({ getAuthToken, handleUnauthorized }), [getAuthToken, handleUnauthorized])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  return useContext(AuthContext)
}
